"use strict";
$(function () {

    const $form_container = $('#contact-form-container');

    console.log($form_container);

    if ($('.wpcf7-form').hasClass('sent')) {
        $form_container.addClass('hide');
    }


    $('.wpcf7-submit').click(function () {
        $form_container.addClass('hide');
    });

});